
<div class=" min-h-screen">
<app-shared-layout [Analysis]="title" [hideAdd]="true"   [useBackButton]="false" >
    <div ngProjectAs="primary-panel" class="flex flex-col gap-5">

     <div class="grid gap-4 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mt-5">
  
  <!-- Total Users -->
  <div class="col-span-1">
    <div
      class="h-[82px] w-full rounded-[20px] shadow flex items-center justify-between px-4 cursor-pointer gap-5 bg-blue-50"
      (click)="cardClicked('total')"
    >
      <div
        class="border border-blue-600 bg-blue-100 rounded-full p-2 text-blue-600 h-10 w-10 flex items-center justify-center"
      >
        <mat-icon class="text-lg">group</mat-icon>
      </div>
      <div class="flex items-center space-x-1 text-blue-600">
        <span class="font-bold text-xl">{{ dashboardData?.totalUsers }}</span>
        <span class="text-sm">Users</span>
      </div>
    </div>
  </div>

  <!-- Active Users -->
  <div class="col-span-1">
    <div
      class="h-[82px] w-full rounded-[20px] shadow flex items-center justify-between px-4 cursor-pointer gap-5 bg-amber-50"
      (click)="cardClicked('active')"
    >
      <div
        class="border border-amber-500 bg-amber-100 rounded-full p-2 text-amber-500 h-10 w-10 flex items-center justify-center"
      >
        <mat-icon class="text-lg">check_circle</mat-icon>
      </div>
      <div class="flex items-center space-x-1 text-amber-600">
        <span class="font-bold text-xl">{{ dashboardData?.activeUsers }}</span>
        <span class="text-sm">Active</span>
      </div>
    </div>
  </div>

  <!-- Inactive Users -->
  <div class="col-span-1">
    <div
      class="h-[82px] w-full rounded-[20px] shadow flex items-center justify-between px-4 cursor-pointer gap-10 bg-red-50"
      (click)="cardClicked('inactive')"
    >
      <div
        class="border border-red-500 bg-red-100 rounded-full p-2 text-red-500 h-10 w-10 flex items-center justify-center"
      >
        <mat-icon class="text-lg">cancel</mat-icon>
      </div>
      <div class="flex items-center space-x-1 text-red-600">
        <span class="font-bold text-xl">{{ dashboardData?.inActiveUsers }}</span>
        <span class="text-sm">Inactive</span>
      </div>
    </div>
  </div>

  <!-- Roles -->
  <div class="col-span-1">
    <div
      class="h-[82px] w-full rounded-[20px] shadow flex items-center justify-between px-4 cursor-pointer gap-10 bg-purple-50"
      (click)="cardClicked('roles')"
    >
      <div
        class="border border-purple-600 bg-purple-100 rounded-full p-2 text-purple-600 h-10 w-10 flex items-center justify-center"
      >
        <mat-icon class="text-lg">category</mat-icon>
      </div>
      <div class="flex items-center space-x-1 text-purple-600">
        <span class="font-bold text-xl">{{ dashboardData?.totalRoles }}</span>
        <span class="text-sm">Roles</span>
      </div>
    </div>
  </div>
</div>


        <div class="grid grid-cols-2 gap-2 mt-12">
            <div class="bg-white  border-1 rounded-3xl p-4">
                <app-bar-graph
                        title="Number of Users per Roles"
                        [data]="barChartData"
                        [height]="500"
                        [gridX]="false"
                        [horizontal]="false"
                        [gridY]="true"
                        [xAxis]="xAxis"
                        [showXlabel]="true"
                        [showYlabel]="true"
                        columnWidth="25%"
                        chart_type="bar"
                        LegendPosition="top"
                        horizontalAlign="right"
                ></app-bar-graph>
            </div>
            <div class="bg-white  border-1 rounded-3xl p-4">
                <app-radialbars-graph
                        *ngIf="pieChartData?.length > 0"
                        [title]="'Proportion By Active Status'"
                        [data]="pieChartData"
                        [height]="500"
                ></app-radialbars-graph>
            </div>
        </div>
    </div>

</app-shared-layout>

</div>
